import { mapState, mapActions } from 'vuex';

export default {
  data() {
    return {
      autosave: null,
      listLaporan: [
        {
          laporan_id: 'pendampingan',
          key: 'download',
          label: `Daftar Laporan Sekolah`,
          acl: this.$allow(`psp-peserta-kp-pa.download`),
          params: {},
        },
        {
          laporan_id: 'sekolah',
          key: 'download',
          label: `Daftar Laporan Pendampingan`,
          acl: this.$allow(`psp-peserta-kp-pa.download`),
          params: { k_laporan: 'pendampingan' },
        },
        {
          laporan_id: 'umum',
          key: 'download-pendampingan',
          label: `Laporan Pendamping IN-PA - Umum`,
          acl: this.$allow(`psp-peserta-kp-pa.download-pendampingan`),
          params: { k_laporan: 'umum' },
        },
        {
          laporan_id: 'sdm',
          key: 'download-pendampingan',
          label: `Laporan Pendamping IN-PA - SDM`,
          acl: this.$allow(`psp-peserta-kp-pa.download-pendampingan`),
          params: { k_laporan: 'sdm' },
        },
        {
          laporan_id: 'anggaran',
          key: 'download-pendampingan',
          label: `Laporan Pendamping IN-PA - Anggaran`,
          acl: this.$allow(`psp-peserta-kp-pa.download-pendampingan`),
          params: { k_laporan: 'anggaran' },
        },
        {
          laporan_id: 'teknologi',
          key: 'download-pendampingan',
          label: `Laporan Pendamping IN-PA - Teknologi`,
          acl: this.$allow(`psp-peserta-kp-pa.download-pendampingan`),
          params: { k_laporan: 'teknologi' },
        },
        {
          laporan_id: 'kegiatan-pembelajaran',
          key: 'download-pendampingan',
          label: `Laporan Pendamping IN-PA - Kegiatan Pembelajaran`,
          acl: this.$allow(`psp-peserta-kp-pa.download-pendampingan`),
          params: { k_laporan: 'kegiatan-pembelajaran' },
        },
        {
          laporan_id: 'dukungan-pemda',
          key: 'download-pendampingan',
          label: `Laporan Pendamping IN-PA - Dukungan Pemerintah Daerah`,
          acl: this.$allow(`psp-peserta-kp-pa.download-pendampingan`),
          params: { k_laporan: 'dukungan-pemda' },
        },
        {
          laporan_id: 'dukungan-sekolah',
          key: 'download-pendampingan',
          label: `Laporan Pendamping IN-PA - Dukungan Internal Sekolah`,
          acl: this.$allow(`psp-peserta-kp-pa.download-pendampingan`),
          params: { k_laporan: 'dukungan-sekolah' },
        },
        {
          laporan_id: 'kondisi-mendesak',
          key: 'download-pendampingan',
          label: `Laporan Pendamping IN-PA - Kondisi Mendesak`,
          acl: this.$allow(`psp-peserta-kp-pa.download-pendampingan`),
          params: { k_laporan: 'kondisi-mendesak' },
        },
      ],
      mInstrumens: {
        dasar: 'Pertanyaan Dasar',
        rencana: 'Tahapan Perencanaan IKM di Satuan Pendidikan',
        pelaksanaan: 'Tahapan Pelaksanaan IKM di Satuan Pendidikan',
        efektivitas: 'Efektivitas kepemimpinan Kepala Sekolah',
        sdm: 'Sumber Daya Manusia (SDM)',
        anggaran: 'Anggaran',
        teknologi: 'Teknologi',
        pembelajaran: 'Kegiatan Pembelajaran',
        pemda: 'Dukungan Pemerintah Daerah',
        internal: 'Dukungan Internal Sekolah',
        mendesak: 'Kondisi Mendesak Dasar',
        info: 'Informasi Dasar',
        lain: 'Lainnya',
      },
      current: {},
    };
  },
  computed: {
    ...mapState('preferensi', {
      preferensi: (state) => state.data,
      pa: (state) => (state.data && state.data.pelatih_ahli) || {},
      configPendampingan: (state) => (state.data && state.data.pendampingan && state.data.pendampingan['kp-pa']) || {},
      gelombangPendampingan: (state) => (state.data?.pelatih_ahli_gelombang ?? []).reverse(),
      perangkat: (state) => (state.menu && state.menu.perangkat) || {},
    }),

    akunId() {
      return this.$getDeepObj(this, 'preferensi.akun.akun_id');
    },

    allowDownload() {
      return this.listLaporan.filter((item) => this.$allow(item.acl)).length > 0;
    },

    isMultiDasar() {
      return [2, 3].includes(this.versi);
    },
  },
  methods: {
    ...mapActions('master', ['getMasters']),

    onDetail(item) {
      clearInterval(this.autosave);
      this.$router.push({
        name: 'detail-pendampingan',
        params: { detail_id: item.psp_kp_pa_id },
      });
    },

    onAdd() {
      this.$set(this.formulir, 'form', 'FormKelompok');
      this.$set(this.formulir, 'title', 'Tambah Kelompok Pendampingan PA');
      this.$set(this.formulir, 'id', null);

      this.$refs.modal.open();

      this.$nextTick(() => {
        this.$refs.formulir.reset();
        this.$set(this.formulir, 'init', null);
      });
    },

    async onEdit(item) {
      this.$set(this.formulir, 'form', 'FormKelompok');
      this.$set(this.formulir, 'title', 'Ubah Kelompok Pendampingan PA');
      this.$set(this.formulir, 'id', item.psp_kp_pa_id);
      this.$set(this.formulir, 'init', null);
      this.$set(this.formulir, 'useSave', true);

      // fetch detail
      const { data } = await this.getDetail({ id: item.psp_kp_pa_id });
      this.$refs.modal.open();

      this.$nextTick(() => {
        this.$refs.formulir.reset();
        this.$set(this.formulir, 'init', data);
      });
    },

    onEditPendampingan(kPendampingan) {
      const pendampingan = this.$getDeepObj(this.pendampingans, `${kPendampingan}`) || null;
      const cfgPendampingan = (this.config && this.config['pendampingan_ke-pmo']) || {};
      const gelombang = this.$getDeepObj(this.detail, 'gelombang') || 1;

      this.$set(this.formulir, 'gelombang', gelombang);
      this.$set(this.formulir, 'form', 'FormPendampingan');
      this.$set(this.formulir, 'title', `Jadwal Pertemuan ke ${cfgPendampingan && cfgPendampingan[kPendampingan]}`);
      this.$set(this.formulir, 'id', kPendampingan);
      this.$set(this.formulir, 'nama', (cfgPendampingan && cfgPendampingan[kPendampingan]) || '');
      this.$set(this.formulir, 'init', null);
      this.$set(this.formulir, 'useSave', true);
      this.$set(this.formulir, 'pendampingan_id', (pendampingan && pendampingan.psp_kp_pendampingan_id) || null);
      this.$refs.modal.open();

      this.$nextTick(() => {
        this.$refs.formulir.reset();
        this.$set(this.formulir, 'init', pendampingan);
        clearInterval(this.autosave);
      });
    },

    async onKuisioner({ data, grup, options, dasarKe, isEditSaran }) {
      const cfgPendampingan =
        (this.config && this.config[this.isMultiDasar ? 'pendampingan_ke-pmo' : 'pendampingan_ke']) || {};
      const pendampingan = this.$getDeepObj(this, `pendampingans.${this.kPertemuan}`) || null;
      const pspKpPaPendampinganId = this.$getDeepObj(pendampingan, 'psp_kp_pa_pendampingan_id') || '';
      const pspKpPaSekolahId = this.$getDeepObj(data, 'psp_kp_pa_sekolah_id') || '';
      const pspKpPaSekolah = this.$getDeepObj(data, 'sekolah') || '';

      this.$set(this.formulir, 'form', (options && options.form) || 'FormKuisioner');
      this.$set(
        this.formulir,
        'title',
        (options && options.title) || `Laporan PMO - ${this.mInstrumens[grup]} ${dasarKe ? `Kegiatan ${dasarKe}` : ''}`
      );
      this.$set(this.formulir, 'id', pspKpPaPendampinganId);
      this.$set(this.formulir, 'sekolah_id', pspKpPaSekolahId);
      this.$set(this.formulir, 'isPreview', false);
      this.$set(this.formulir, 'isEditSaran', isEditSaran);
      this.$set(this.formulir, 'useSave', true);
      this.$set(this.formulir, 'init', null);
      this.$set(this.formulir, 'berkases', []);

      if (!this.meta.is_edit && !isEditSaran) {
        this.$error(
          `Anda sudah tidak dapat mengubah laporan pada periode ${this.mPertemuan &&
            this.mPertemuan[this.pendampingan_ke]}`
        );
        return;
      }

      const resp = await this.getInstrument({
        id: this.$getDeepObj(pendampingan, 'psp_kp_pa_pendampingan_id'),
        sekolah_id: this.$getDeepObj(data, 'psp_kp_pa_sekolah_id'),
        grup: grup,
      });

      let berkases = this.$getDeepObj(resp, 'data.psp_kp_pa_sekolah_laporan_berkases.data') || [];
      if (dasarKe) {
        berkases = this.$getDeepObj(resp, `meta.laporan_dasar.${dasarKe}.psp_kp_pa_sekolah_laporan_berkases`) || [];
      }

      let formulir = (resp && resp.data) || [];
      if (dasarKe) {
        formulir = this.getLaporanDasarKe(this.$getDeepObj(data, 'psp_kp_pa_sekolah_id'), dasarKe);
      }

      const init = {
        grup: grup,
        kPertemuan: this.kPertemuan,
        jadwal: (cfgPendampingan && cfgPendampingan[this.kPertemuan]) || '-',
        ptk: this.$getDeepObj(this.preferensi, 'ptk') || {},
        sekolah: data,
        formulir,
        pspKpPaSekolah: pspKpPaSekolah || {},
        pendampinganId: this.$getDeepObj(pendampingan, 'psp_kp_pa_pendampingan_id'),
        dasarKe,
      };
      this.$refs.modal.open();

      this.$nextTick(() => {
        this.$refs.formulir.reset();
        this.$set(this.formulir, 'init', init);
        this.$set(this.formulir, 'berkases', berkases);
      });
    },

    async onSelesai({ data, grup }) {
      const cfgPendampingan =
        (this.config && this.config[this.isMultiDasar ? 'pendampingan_ke-pmo' : 'pendampingan_ke']) || {};
      const pendampingan = this.$getDeepObj(this, `pendampingans.${this.kPertemuan}`) || null;
      const pspKpPaPendampinganId = this.$getDeepObj(pendampingan, 'psp_kp_pa_pendampingan_id') || '';
      const pspKpPaSekolahId = this.$getDeepObj(data, 'psp_kp_pa_sekolah_id') || '';
      const pspKpPaSekolah = this.$getDeepObj(data, 'sekolah') || '';

      this.$set(this.formulir, 'form', 'FormSelesai');
      this.$set(this.formulir, 'title', `Set Selesai Laporan PMO - ${this.mInstrumens[grup]}`);
      this.$set(this.formulir, 'id', pspKpPaPendampinganId);
      this.$set(this.formulir, 'sekolah_id', pspKpPaSekolahId);
      this.$set(this.formulir, 'isPreview', false);
      this.$set(this.formulir, 'useSave', true);
      this.$set(this.formulir, 'init', null);
      this.$set(this.formulir, 'berkases', []);

      const resp = await this.getInstrument({
        id: this.$getDeepObj(pendampingan, 'psp_kp_pa_pendampingan_id'),
        sekolah_id: this.$getDeepObj(data, 'psp_kp_pa_sekolah_id'),
        grup: grup,
      });

      const berkases = this.$getDeepObj(resp, 'data.psp_kp_pa_sekolah_laporan_berkases.data') || [];
      const formulir = (resp && resp.data) || [];
      const init = {
        grup: grup,
        kPertemuan: this.kPertemuan,
        jadwal: (cfgPendampingan && cfgPendampingan[this.kPertemuan]) || '-',
        ptk: this.$getDeepObj(this.preferensi, 'ptk') || {},
        sekolah: data,
        formulir,
        pspKpPaSekolah: pspKpPaSekolah || {},
        pendampinganId: this.$getDeepObj(pendampingan, 'psp_kp_pa_pendampingan_id'),
      };

      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
        this.$set(this.formulir, 'init', init);
        this.$set(this.formulir, 'berkases', berkases);
      });
    },

    async onRefresh(options) {
      const { data, meta } = await this.getInstrument({
        id: this.$getDeepObj(options, 'psp_kp_pa_pendampingan_id'),
        sekolah_id: this.$getDeepObj(options, 'psp_kp_pa_sekolah_id'),
      });

      let berkases = this.$getDeepObj(data, 'psp_kp_pa_sekolah_laporan_berkases.data') || [];
      if (options.dasarKe) {
        berkases = this.$getDeepObj(meta, `laporan_dasar.${options.dasarKe}.psp_kp_pa_sekolah_laporan_berkases`) || [];
      }

      this.$nextTick(() => {
        this.$set(this.formulir, 'berkases', berkases);
      });
    },

    onSave() {
      this.save();
    },

    save(isAutosave = false) {
      const item = this.$refs.formulir.getValue();
      const form = (item && item.form) || {};
      const grup = (item && item.grup) || '';
      const dasarKe = (item && item.dasar_ke) || '';
      const kBelajarPsp = (item && item.k_belajar_psp) || '';
      const id = this.formulir.id;
      const validate = this.$refs.formulir.validate();

      if (!validate) {
        this.$refs.modal.loading = false;
        return;
      }

      // auto save tanpa loading
      if (this.$refs?.modal) this.$refs.modal.loading = !isAutosave;
      this.$store.commit('SET_AUTOSAVE', isAutosave);

      if (this.formulir.form === 'FormSelesai') {
        this.saveSelesaiLaporan(id, item);
        return;
      }

      if (this.formulir.form === 'FormPendampingan') {
        this.savePendampingan(id, form);
        return;
      } else if (['FormKuisioner', 'FormIndividu'].includes(this.formulir.form)) {
        this.saveKuisioner(id, { form, kBelajarPsp, grup, dasarKe }, isAutosave);
        return;
      }

      this[id ? 'update' : 'create']({ id: id, params: form })
        .then(() => {
          this.$success(`Data kelompok berhasil di${id ? 'update' : 'tambahkan'}`);
          this.$refs.modal.close();
          if (this.id) {
            this.getPendampingan();
          } else {
            this.onReload();
          }
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },

    saveSelesaiLaporan(id, params) {
      const sekolah_id = this.$getDeepObj(this.formulir, 'sekolah_id');
      this.updateSelesai({ id, sekolah_id, params })
        .then(() => {
          this.$success(`Data berhasil disimpan`);
          this.$refs.modal.close();
          this.getSekolahPendampingan(this.kPertemuan);
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },

    savePendampingan(id, form) {
      const formData = new FormData();
      const formId = this.$getDeepObj(this.detail, 'psp_kp_pa_id');

      Object.keys(form).forEach((key) => {
        if (this.$isArray(form[key])) {
          (form[key] || []).forEach((item, index) => {
            Object.keys(item).forEach((i) => {
              if (item[i]) {
                formData.append(`data_meeting[${index}][${i}]`, item[i] || '');
              }
            });
          });
        } else {
          formData.append(key, form[key]);
        }
      });

      this.updatePendampingan({ id: formId, params: formData })
        .then(() => {
          this.$success('Data pendampingan berhasil di update');
          this.getPendampingan();
          this.$refs.modal.close();
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },

    saveKuisioner(id, params = {}, autoSave = false) {
      if (!Object.keys(params && params.form).length) return;

      const { form, kBelajarPsp, grup, dasarKe } = params;
      const formData = new FormData();
      formData.append('autosave', autoSave ? 1 : 0);

      if (dasarKe) {
        formData.append('dasar_ke', dasarKe);
      }

      if (this.formulir.form === 'FormKuisioner') {
        if (['info'].includes(grup)) {
          Object.keys(form).forEach((key) => {
            if (typeof form[key] === 'object') {
              Object.keys(form[key]).forEach((item) => {
                formData.append(`data_meeting_pmo[${item}][nama]`, form[key][item]['nama']);
                formData.append(`data_meeting_pmo[${item}][url_meeting]`, form[key][item]['url_meeting']);
              });
            } else {
              formData.append(key, form[key]);
            }
          });
        } else {
          formData.append('k_belajar_psp', kBelajarPsp);
          formData.append('grup', grup);
          form.forEach((item, index) => {
            Object.keys(item).forEach((s) => {
              formData.append(`instrumen[${index}][${s}]`, item[s]);
            });
          });
        }
      } else if (this.formulir.form === 'FormIndividu') {
        for (const key in params.form) {
          if (Array.isArray(params.form[key])) {
            for (const a in params.form[key]) {
              formData.append(`${key}[${a}]`, params.form[key][a] || '');
            }
          } else {
            formData.append(key, params.form[key] || '');
          }
        }
      }

      let update = 'updateLaporan';
      if (this.formulir.isEditSaran) {
        update = 'updateSaran';
      }

      this[update]({
        id: id,
        sekolah_id: this.$getDeepObj(this.formulir, 'sekolah_id'),
        params: formData,
        form: this.formulir.form,
        dasarKe,
      })
        .then(() => {
          if (!autoSave) {
            this.$success('Data laporan berhasil di update');
            this.getSekolahPendampingan(this.kPertemuan);
            this.$refs.modal.close();
            clearInterval(this.autosave);
          }
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },

    onDelete(item) {
      this.$confirm(
        `<span class="black--text">Anda yakin ingin menghapus data pendampingan <strong>${item.nama ||
          '-'}</strong> ?</span>`,
        `Hapus Pendampingan`,
        {
          tipe: 'error',
          data: '',
        }
      ).then(() => {
        this.delete({ id: item.psp_kp_pa_id }).then(() => {
          this.$success('Data pendampingan berhasil di hapus');
          this.onReload();
        });
      });
    },

    getPendampingan(resetTab = false) {
      if (!this.id) return;
      this.getDetail({ id: this.id })
        .then(({ data, meta }) => {
          this.tab = resetTab ? 0 : this.tab;
          this.detail = data || {};
          this.config = meta?.config || {};
          this.current = {
            gelombang: meta['gelombang'] || 1,
            pendampingan_ke: meta['pendampingan_ke'] || 0,
            pendampingan_ke_pmo: meta['pendampingan_ke-pmo'] || 0,
          };
          this.mPendampingan = Object.keys(this.$getDeepObj(this.config, 'pendampingan_ke') || {}) || [];
          this.mPendampinganPmo = [];

          // set mPendampinganPmo
          let confPendampinganGelombang = [...[], ...(this.$getDeepObj(this.config, 'pendampingan-gelombang') || [])];
          let confPendampinganPmo = this.$getDeepObj(this.config, 'pendampingan_ke-pmo') || {};
          for (const pendKePmo of confPendampinganGelombang) {
            if (confPendampinganPmo[pendKePmo]) {
              this.mPendampinganPmo.push(pendKePmo);
            }
          }

          // add masters mGelombang profil
          const gelombangProfilPa = (this.config['gelombang-profil-pa'] || []).reverse().map((gelombang) => {
            return {
              text: `Angkatan ${gelombang}`,
              value: gelombang,
            };
          });
          this.$set(this.masters, 'gelombang-profil-pa', gelombangProfilPa);
        })
        .then(() => {
          this.setPertemuan();
          // this.getSekolahPendampingan(this.kPertemuan || 1);
        })
        .finally(() => {
          this.getMasters('lokakarya_moda_psp;aktif;kp_topik_psp;kp_subtopik_psp|value:k_kp_topik_psp+keterangan').then(
            (data) => {
              Object.keys(data).forEach((key) => {
                this.$set(this.masters, key, data[key]);
              });
            }
          );
        });
    },

    getLastPendampingan(item) {
      const pendampingans = [
        ...[],
        ...(this.$getDeepObj(item, 'psp_kp_pa_pendampingans.data') ||
          this.$getDeepObj(item, 'psp_kp_pa_pendampingans') ||
          []),
      ];
      if (!pendampingans.length) return false;

      const pendampingan = [...[], ...pendampingans].pop();
      return pendampingan.pendampingan_ke ? pendampingan : {};
    },

    onDownloadList() {
      let url = {};
      this.$confirm('Pilih jenis Berkas yang ingin di Unduh?', 'Unduh Berkas', {
        tipe: 'info',
        icon: 'mdi-download',
        form: {
          desc: 'Laporan Berkas',
          render: (h) => {
            return h(
              'select',
              {
                class: 'custom-select',
                domProps: {
                  value: '',
                },
                on: {
                  input: function(event) {
                    url.dokumen = event.target.value;
                  },
                },
              },
              [
                h('option', { attrs: { value: '' } }, '-- Pilih Laporan Berkas --'),
                this.listLaporan
                  .filter((laporan) => this.$allow(laporan.acl))
                  .map((item) => h('option', { attrs: { value: item.laporan_id } }, item.label)),
              ]
            );
          },
        },
        lblConfirmButton: 'Unduh',
      }).then(() => {
        if (!url.dokumen) {
          this.$error('Silakan pilih laporan yang ingin diunduh!');
          return;
        }

        const laporan = this.listLaporan.find((item) => item.laporan_id === url.dokumen) || {};

        const params = Object.assign({}, laporan.params);
        this.downloadList({ params, url: laporan.key }).then((url) => {
          this.$downloadFile(url);
        });
      });
    },

    onSetAutoSave() {
      this.autosave = setInterval(() => {
        this.save(true);
      }, 3 * 60 * 1000);
    },

    onCloseModal() {
      clearInterval(this.autosave);
      if (this.$refs?.modal) this.$refs.modal.dialog = false;
    },

    async onViewLaporan({ data, grup, options, dasarKe }) {
      const cfgPendampingan =
        (this.config && this.config[this.isMultiDasar ? 'pendampingan_ke-pmo' : 'pendampingan_ke']) || {};
      const pspKpPaPendampinganId = this.$getDeepObj(pendampingan, 'psp_kp_pa_pendampingan_id') || '';
      const pspKpPaSekolahId = this.$getDeepObj(data, 'psp_kp_pa_sekolah_id') || '';
      const pspKpPaSekolahs = this.$getDeepObj(this.detail, 'psp_kp_pa_sekolahs.data') || [];
      const pspKpPaSekolah = pspKpPaSekolahs.filter((sekolah) => sekolah.id === pspKpPaSekolahId);

      let pendampingan = this.$getDeepObj(this, `pendampingans.${this.kPertemuan}`) || null;

      this.$set(this.formulir, 'form', options.form);
      this.$set(this.formulir, 'title', options.title);
      this.$set(this.formulir, 'id', pspKpPaPendampinganId);
      this.$set(this.formulir, 'sekolah_id', pspKpPaSekolahId);
      this.$set(this.formulir, 'isPreview', true);
      this.$set(this.formulir, 'isEditSaran', false);
      this.$set(this.formulir, 'useSave', false);
      this.$set(this.formulir, 'init', null);
      this.$set(this.formulir, 'berkases', []);

      const resp = await this.getInstrument({
        id: this.$getDeepObj(pendampingan, 'psp_kp_pa_pendampingan_id'),
        sekolah_id: this.$getDeepObj(data, 'psp_kp_pa_sekolah_id'),
        grup: grup,
      });

      let berkases = this.$getDeepObj(resp, 'data.psp_kp_pa_sekolah_laporan_berkases.data') || [];
      if (dasarKe) {
        berkases = this.$getDeepObj(resp, `meta.laporan_dasar.${dasarKe}.psp_kp_pa_sekolah_laporan_berkases`) || [];
      }

      let formulir = (resp && resp.data) || [];
      if (dasarKe) {
        formulir = this.getLaporanDasarKe(this.$getDeepObj(data, 'psp_kp_pa_sekolah_id'), dasarKe);
      }

      const init = {
        grup: grup,
        config: this.config,
        kPertemuan: this.kPertemuan,
        jadwal: (cfgPendampingan && cfgPendampingan[this.kPertemuan]) || '-',
        ptk: this.$getDeepObj(this.preferensi, 'ptk') || {},
        sekolah: data,
        formulir,
        pspKpPaSekolah: pspKpPaSekolah[0] || {},
        pendampinganId: this.$getDeepObj(pendampingan, 'psp_kp_pa_pendampingan_id'),
        dasarKe,
      };

      this.$refs.modal.open();

      this.$nextTick(() => {
        this.$refs.formulir.reset();
        this.$set(this.formulir, 'init', init);
        this.$set(this.formulir, 'berkases', berkases);
      });
    },

    getLaporanDasarKe(id, dasarKe) {
      if (!this.dasars[id]) {
        return {};
      }

      const laporan = this.dasars[id].filter((dasar) => +dasar.dasar_ke === dasarKe) || [];
      return laporan[0] || {};
    },
  },
};
